export enum EInputStyleType {
  Primary = "primary",
  Secondary = "secondary",
  Responsive = "responsive",
  Number = "number",
  Rounded = "rounded",
}
